<template>
    <v-container fill-height fluid grid-list-xl class="pt-0">
        <v-layout wrap>
            <v-flex xs12 class="pt-0">
                <v-btn class="mb-0" small color="success" href="/calls-mobile"
                    >Calls</v-btn
                >
                <material-card color="green" :title="title">
                    <div>
                        <div v-for="(message, index) in getLastMessages()">
                            <div>
                                <v-icon
                                    class="mr-2 "
                                    dark
                                    :color="getStatusIconColor(message.Status)"
                                    >{{ getStatusIcon(message.Status) }}</v-icon
                                >{{ message.Status
                                }}<span class="font-weight-medium">{{
                                    " | " + getMessageDuration(message)
                                }}</span>
                                <v-icon
                                    @click="openStateDialog(message)"
                                    style="margin-left: 54px"
                                    dark
                                    color="blue"
                                    >mdi-city</v-icon
                                >
                            </div>
                            <div class="my-1">{{ message.Date }}</div>
                            <div>
                                {{
                                    message.SenderName +
                                        "        " +
                                        message.SenderPhone
                                }}
                            </div>
                            <audio
                                controls
                                class="mt-2"
                                style="width: 100%;"
                                :src="message.RecordingURL"
                            ></audio>
                            <v-divider
                                class="mb-2 mt-1"
                                v-if="index + 1 < getLastMessages().length"
                                :key="index"
                            ></v-divider>
                        </div>
                    </div>
                </material-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="viewMessageDialog" max-width="900">
            <v-card class="p-4">
                <pre>{{ viewMessageText | pretty }}</pre>
                <v-card-actions>
                    <v-btn @click="viewMessageDialog = false" color="#999" dark
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="stateDialog">
            <v-card class="px-3 pt-4 pb-2">
                <v-text-field label="State" v-model="state"></v-text-field>
                <v-card-actions class="mx-1">
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        :loading="processing"
                        color="success"
                        @click="saveState"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import * as firebase from "firebase/app";
import "firebase/database";
import moment from "moment";

export default {
    data() {
        return {
            title: "Credit",
            rowsPerPageItems: [10, 20],
            pagination: {
                totalItems: 0,
                rowsPerPage: 10,
                page: 1,
            },

            isMobile: false,

            headers: [
                { value: "Status", text: "Status" },
                { value: "Timestamp", text: "Timestamp" },
                { value: "SenderName", text: "Sender" },
                { value: "SenderPhone", text: "Sender Phone" },
                { value: "RecordingURL", text: "Recording" },
                { value: "phoneNumberList", text: "Sent To" },
            ],

            messages: [],

            viewMessageDialog: false,
            viewMessageText: "",
            stateDialog: false,
            state: "",
            clickedMessage: "",
            processing: false,
        };
    },
    computed: {
        pages() {
            return this.pagination.rowsPerPage
                ? Math.ceil(
                      this.pagination.totalItems / this.pagination.rowsPerPage,
                  )
                : 0;
        },
    },
    filters: {
        pretty: function(value) {
            if (!value) return "";

            return JSON.stringify(value, null, 2);
        },
    },
    created() {
        this.firebaseSetup();
        this.isMobile = window.innerWidth < 551;
    },
    methods: {
        firebaseSetup() {
            const firebaseConfig = {
                apiKey: "Xs6kU5UjjL8n5LdLQJMGnWcaEietBLrj5U9FnpIb",
                authDomain: "broadcast-b7a56.firebaseapp.com",
                databaseURL: "https://broadcast-b7a56.firebaseio.com",
                projectId: "broadcast-b7a56",
            };

            // Initialize Firebase
            if (!firebase.apps.length) {
                firebase.initializeApp(firebaseConfig);
            }

            var database = firebase.database();
            var ref = firebase.database().ref("messages");

            const messagesRef = ref.orderByKey().limitToLast(100);

            messagesRef.on(
                "value",
                (snapshot) => {
                    const messages = Object.values(snapshot.val()).map(
                        (message) => {
                            message.SenderPhone = this.formatPhoneNumber(
                                message.SenderPhone,
                            );

                            message.PhoneNumberList = message.PhoneNumbers.map(
                                (m) => this.formatPhoneNumber(m.Phone),
                            ).join(",");

                            message.Date = moment(message.Timestamp).format(
                                "LLL",
                            );

                            return message;
                        },
                    );
                    this.messages = messages.sort((a, b) => {
                        if (Date.parse(a.Timestamp) > Date.parse(b.Timestamp))
                            return -1;
                        if (Date.parse(a.Timestamp) < Date.parse(b.Timestamp))
                            return 1;
                        return 0;
                    });

                    this.pagination.totalItems = this.messages.length;
                },
                function(error) {
                    console.log("Error: " + error.code);
                },
            );

            var accountRef = firebase.database().ref("account");

            const accounts = accountRef.orderByKey().limitToLast(1);

            accounts.on(
                "value",
                (snapshot) => {
                    const accountInfo = Object.values(snapshot.val()).map(
                        (account) => {
                            this.title =
                                "Credit: $" + account.Credit.toFixed(2);

                            return account;
                        },
                    );
                },
                function(error) {
                    console.log("Error: " + error.code);
                },
            );
        },
        openStateDialog(message) {
            this.stateDialog = true;
            this.clickedMessage = message;
        },
        async saveState() {
            try {
                this.processing = true;

                await this.$http.post(
                    this.getDomain() +
                        "/api/broadcast/UpdateState?originalURL=" +
                        this.clickedMessage.OriginalRecordingURL +
                        "&state=" +
                        this.state,
                );

                this.processing = false;
                this.stateDialog = false;
            } catch (e) {
                this.processing = false;
            }
        },
        getLastMessages() {
            console.log(this.messages);

            return this.messages
                .filter((m) => m.MessageNumber == 1)
                .slice(0, 30);
        },
        getMessageDuration(message) {
            var minutes = message.OriginalDuration; // given value in minutes
            var seconds = minutes * 60; // convert minutes to seconds
            var time = new Date(seconds * 1000).toISOString().substr(14, 5);

            return time;
        },
        formatPhoneNumber(phoneNumberString) {
            var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
            var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                return "(" + match[1] + ") " + match[2] + "-" + match[3];
            }
            return null;
        },
        getDomain() {
            return window.location.origin.startsWith("http://localhost:8080") ||
                window.location.origin.startsWith("http://localhost:8092")
                ? "https://localhost:44337"
                : "https://broadcastmessageswercber.azurewebsites.net";
        },
        getStatusIcon(status) {
            switch (status) {
                case "Completed":
                    return "mdi-check-circle";
                case "InProgress":
                case "Queued":
                    return "mdi-progress-upload";
                case "Pending":
                    return "mdi-clock";
            }
        },
        getStatusIconColor(status) {
            switch (status) {
                case "Completed":
                    return "success";
                case "InProgress":
                case "Queued":
                    return "#42A5F5";
                case "Pending":
                    return "#fdb400";
            }
        },
        viewMessage(message) {
            this.viewMessageText = message;
            this.viewMessageDialog = true;

            console.log(JSON.stringify(message, null, 2));
        },
    },
};
</script>
<style>
tbody tr:nth-child(even) {
    background-color: #eee;
}
</style>
